<template>
  <div>
    {{ finalAmount | currency(order.currency_label) }}
    <div v-if="showDifference" class="text-muted text-sm whitespace-no-wrap">
      ({{ order.amount | currency(order.currency_label) }})
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderFinalAmount',

  props: {
    order: {
      type: Object,
      require: true,
      default: () => {
        return {}
      },
    },
  },

  computed: {
    showDifference() {
      return (
        this.order.status === 'partial_refund' || this.order.refund_requested
      )
    },
    finalAmount() {
      return this.showDifference
        ? this.order.amount -
            this.order.amount_refund_requested -
            this.order.amount_refunded
        : this.order.amount
    },
  },
}
</script>
